import { Fragment } from 'react';
import { COUNTDOWN_UNITS } from '../constants';
const CountdownSkeleton = () => {
  return <div className='py-3' data-sentry-component="CountdownSkeleton" data-sentry-source-file="countdown-skeleton.tsx">
            <div className='homepage-container'>
                <div className='mx-auto h-5 w-36 animate-pulse rounded bg-[var(--landing-skeleton-pulse)] lg:h-6 lg:w-44' />

                <div className='mx-auto mb-2 mt-3 h-4 w-64 animate-pulse rounded bg-[var(--landing-skeleton-pulse)] lg:mb-5 lg:mt-4 lg:h-5 lg:w-80' />

                <div className='flex items-center justify-center gap-1.5 lg:gap-3'>
                    {COUNTDOWN_UNITS.map((_, index) => <Fragment key={index}>
                            {index > 0 ? <div className='flex flex-col items-center gap-px'>
                                    <div className='h-1 w-1 rounded-[1px] bg-[var(--landing-skeleton-pulse)] lg:h-1.5 lg:w-1.5' />
                                    <div className='h-1 w-1 rounded-[1px] bg-[var(--landing-skeleton-pulse)] lg:h-1.5 lg:w-1.5' />
                                </div> : null}

                            <div>
                                <div className='h-14 w-14 animate-pulse rounded-full bg-[var(--landing-skeleton-pulse)] lg:h-19 lg:w-19' />
                                <div className='mx-auto mt-1 h-3 w-8 animate-pulse rounded bg-[var(--landing-skeleton-pulse)] lg:mt-2 lg:h-4 lg:w-10' />
                            </div>
                        </Fragment>)}
                </div>
            </div>
        </div>;
};
export default CountdownSkeleton;